export const FAQ_URL = 'https://colonist.io/faq';
